export function PayDisclaimer() {
  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <p>
            The BLM uses pay.gov for payment transactions. To complete the next step, click the payment button below to be taken
            to pay.gov to complete your payment transaction. When you are finished, you will be returned to this site.
          </p>
        </div>
      </div>
    </div>
  )
}